import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { validate, validators } from 'validate-redux-form';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
} from "../../Utils/renderField/renderField";

function ELZMForm(props) {
    const { handleSubmit, crear, modulo } = props;
    
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar código de unificación' : 'Crear código de unificación';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver código de unificación';
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <form onSubmit={handleSubmit}>
                <br />
                <div className="mb-4 card card-small text-white bg-dark mb-3">
                    <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                        <div className="d-flex flex-column flex-1 mx-4">
                            {(crear || (crear === false && editar === false)) &&
                                <div className='mb-2 row'>
                                    <div className='col-2'>
                                        <Field
                                            autoFocus={autoFocus}
                                            name="codigo_letra"
                                            placeholder="Código letra"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Código letra"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="familia_nuclear"
                                            placeholder="Familia nuclear"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Familia nuclear"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="fabricante"
                                            placeholder="Fabricante"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Fabricante"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="marca"
                                            placeholder="Marca"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Marca"
                                        />
                                    </div>
                                </div>
                            }
                            {editar &&
                                <div className='mb-2 row'>
                                    <div className='col-2'>
                                        <Field
                                            autoFocus={autoFocus}
                                            name="codigo_letra"
                                            placeholder="Código letra"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Código letra"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="familia_nuclear"
                                            placeholder="Familia nuclear"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Familia nuclear"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="fabricante"
                                            placeholder="Fabricante"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Fabricante"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="marca"
                                            placeholder="Marca"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Marca"
                                        />
                                    </div>
                                </div>
                            }
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        type='submit'
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                <a
                                    href={`/#/registro_sanitario/${id_emp[5]}/elzm`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

ELZMForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormELZM',
    validate: (data) => {
        return validate(data, {
            numero: validators.exists()('Este campo es requerido'),
            descripcion: validators.exists()('Este campo es requerido'),
        });
    },
})(ELZMForm);
